// extracted by mini-css-extract-plugin
module.exports = {"root":"LandingCategoryBanner_root__zG0Dq","item":"LandingCategoryBanner_item__gAxQ6","img":"LandingCategoryBanner_img__MoahX","text":"LandingCategoryBanner_text__pHPTc"};